import React, {useState, useEffect} from 'react'
import Loading from '../general/Loading.js';


const Enquiry = () => {
        const [enquiry, setEnquiry] = useState([]);
            const [loading, setLoading] = useState(false);
    

            useEffect(() => {
                const fetchEnquiry = async () => {
                    setLoading(true);
                    try {
                        const response = await fetch('https://api.siddhabhairabistore.com/get-contact');
        
                        if (response.ok) {
                            const data = await response.json();
                            setEnquiry(data);
                            setLoading(false);
                        } else {
                            setLoading(false);
                            console.error('Failed to fetch users');
                        }
                    } catch (error) {
                        setLoading(false);
                        console.error('Error fetching data:', error);
                    }
                };
        
                fetchEnquiry();
            }, []);
        

              const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', '');
  };

  return (
    <>
          <section className='my-4'>
      <div className='px-4'>
        <div className='d-flex justify-content-between'>
          <p className='page-title'>Form Enquiries</p>
          {/* <button className='edit-btn' onClick={() => navigate('/add-product')}>Add Product</button> */}
        </div>

        <div className='table-responsive bg-white rounded-2 px-3 py-3'>
          <table className='w-100'>
              <tr className='inventory-row d-flex'>
                <th style={{flex: 1}}>Enquired On</th>
                <th style={{flex: 1}}>Name</th>
                <th style={{flex: 1}}>Mobile</th>
                <th style={{flex: 1}}>Email</th>
                <th style={{flex: 1}}>Message</th>
              </tr>

<hr />

              {enquiry.map(product => (
                <tr key={product.id} className='inventory-row d-flex'>
                  <td style={{flex: 1}}>{formatDateTime(product.date)}</td>
                  <td style={{flex: 1}}>{product.name}</td>
                  <td style={{flex: 1}}>{product.mobile}</td>
                  <td style={{flex: 1}}>{product.email}</td>
                  <td style={{flex: 1}}>{product.message}</td>

</tr>
              ))}
</table>
</div>

        </div>
        </section>

                    {loading && <Loading setLoading={setLoading} />}

    </>
  )
}

export default Enquiry
